const HTML_TAG_PATTERN = /<[^>]+>/;

function isCmsHtml(value) {
  return typeof value === "string" && HTML_TAG_PATTERN.test(value);
}

function wrapHighlight(value) {
  if (!value) {
    return "";
  }

  if (isCmsHtml(value) && value.includes("cms-heading-highlight")) {
    return value;
  }

  return `<span class="cms-heading-highlight">${value}</span>`;
}

function joinHeadingSegments(segments) {
  let output = "";

  for (const segment of segments) {
    if (!segment) {
      continue;
    }

    if (!output) {
      output = segment;
      continue;
    }

    const leftPlain = output.replace(/<[^>]*>/g, "").replace(/&nbsp;/gi, " ");
    const rightPlain = segment.replace(/<[^>]*>/g, "").replace(/&nbsp;/gi, " ");
    const leftChar = leftPlain.slice(-1);
    const rightChar = rightPlain.slice(0, 1);
    const needsSpace =
      Boolean(leftChar && rightChar) &&
      /[A-Za-z0-9]/.test(leftChar) &&
      /[A-Za-z0-9]/.test(rightChar) &&
      !/\s$/.test(output) &&
      !output.endsWith("&nbsp;") &&
      !/^\s/.test(segment) &&
      !segment.startsWith("&nbsp;");

    output += needsSpace ? ` ${segment}` : segment;
  }

  return output;
}

export function mergeHeroHeadingHtml(parts) {
  if (!parts) {
    return "";
  }

  return joinHeadingSegments([
    parts.beforeSpan1 ?? "",
    parts.span1 ? wrapHighlight(parts.span1) : "",
    parts.middle ?? "",
    parts.span2 ? wrapHighlight(parts.span2) : "",
    parts.afterSpan2 ?? "",
  ]);
}

export function mergeGalleryHeadingHtml(parts, headingHtml) {
  if (typeof headingHtml === "string" && headingHtml.trim()) {
    return headingHtml;
  }

  if (!parts) {
    return "";
  }

  const line1 = joinHeadingSegments([
    parts.line1Before ?? "",
    parts.line1Span ? wrapHighlight(parts.line1Span) : "",
    parts.line1Suffix ?? "",
  ]);
  const line2 = joinHeadingSegments([
    parts.line2Before ?? "",
    parts.line2Span ? wrapHighlight(parts.line2Span) : "",
    parts.line2Suffix ?? "",
  ]);

  return `${line1}<br>${line2}`;
}

export function mergeSplitHeadingHtml(parts) {
  if (!parts) {
    return "";
  }

  if (typeof parts.headingHtml === "string" && parts.headingHtml.trim()) {
    return parts.headingHtml;
  }

  const heading = parts.heading ?? "";
  const highlight = parts.headingHighlight ?? "";
  const suffix = parts.headingSuffix ?? "";

  // Already a full rich heading — don't double-wrap highlight parts.
  if (typeof heading === "string" && heading.includes("cms-heading-highlight") && !highlight) {
    return `${heading}${suffix ? ` ${suffix}` : ""}`.trim();
  }

  return joinHeadingSegments([
    heading,
    highlight ? wrapHighlight(highlight) : "",
    suffix,
  ]);
}

export function mergeThanksHeadingHtml(parts) {
  if (!parts) {
    return "";
  }

  const heading = parts.heading ?? "";
  const highlight = parts.headingHighlight ?? "";
  const suffix = parts.headingSuffix ?? "";

  if (!highlight) {
    return `${heading}${suffix ? ` ${suffix}` : ""}`.trim();
  }

  return `${wrapHighlight(highlight)}${heading ? ` ${heading}` : ""}${suffix ? ` ${suffix}` : ""}`.trim();
}
